module.exports = __webpack_public_path__ + "static/media/fold-multiple.25a5b15e.png";